export const DIFF_FILE_MOUNTED = 'DiffFileMounted';
